const env = process.env.NODE_ENV
var url = 'https://equity.aojuai.com/equityshanxi';
// var url = 'http://192.168.2.75:19091/equityshanxi'; 
// var url = 'https://train.aojuai.com';
// 新服务
const config = {
  development:{
    // baseURL :url//本
    baseURL :url, //线上 
   
  },
  production:{
     baseURL :'https://equity.aojuai.com/equityshanxi',

  }
}
export default {  
  baseURL:config[env].baseURL,
}